import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=6dadf212&scoped=true&"
import script from "./title-bar.vue?vue&type=script&lang=js&"
export * from "./title-bar.vue?vue&type=script&lang=js&"
import style0 from "./title-bar.vue?vue&type=style&index=0&id=6dadf212&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dadf212",
  null
  
)

export default component.exports